import React from 'react';
import _ from 'lodash';
import toTsvString from '../../utils/toTsvString';
import DownloadContainer from 'containers/DownloadContainer';

/* eslint-disable no-unused-vars */
let createIdString = ({ project_id, ...rest }) => (
  Object.keys(rest).map(key => rest[key]).join(', ')
);

let entitiesWithErrors = (entities: Array<Object>): Array<Object> => (
  entities && entities.filter(x => x.errors.length)
);

let flattenErrors = (xs: Array<Object>): Array<Object> => (
  (xs || []).reduce((acc, val) => [
    ...acc,
    ...val.errors.map(error => ({
      entityType: val.type,
      key: error.keys && error.keys[0],
      errorType: error.type,
      message: error.message,
      id: val.unique_keys && (JSON.parse(val.unique_keys) || [])[0]
        ? createIdString(JSON.parse(val.unique_keys)[0]) || val.id || `N/A`
        : val.id || `N/A`
    }))
  ], [])
);

let groupByType = (xs: Array<Object>): Object => (
  (xs || []).reduce((acc, val) => ({
    ...acc,
    [`${val.errorType}/${val.key}`]:
      [ ...(acc[`${val.errorType}/${val.key}`] || []), val ]
  }), {})
);

let flattenedAfterGrouping = (x: Object): Array<Object> => (
  x && Object.keys(x).reduce((acc, key) => [
    ...acc,
    ...x[key],
  ], [])
);

let createErrorMap = _.compose(groupByType, flattenErrors, entitiesWithErrors);
let createTsvString = _.compose(toTsvString, flattenedAfterGrouping);
let createTsvStringFromErrorMap = _.compose(createTsvString, createErrorMap);

export default function ErrorReportContainer({ entities, filename, children, customDataTestID }) {
  return (
    <DownloadContainer
        customDataTestID={customDataTestID}
        body={ entities.length ? createTsvStringFromErrorMap(entities) : `` }
        format="TSV"
        filename={filename}
      >
      { children }
    </DownloadContainer>);
}
